module.exports = __webpack_public_path__ + "img/qingpai_down_code.721b3f00.png";